import React from 'react';
import {Redirect, Route, Switch,} from 'react-router';
import PropTypes from 'prop-types';
import Radium from 'radium';

import Company from './company';
import Clients from './clients';
import Members from './members';
import Statistics from './statistics';
import History from './history';
import {getMemberRole} from '../../../../utils/General';
import config from 'config';

const styles = {
    sideBarWrapper: {
        backgroundColor: '#F2F5FB',
        position: 'fixed',
        top: '60px',
        left: '60px',
        height: '100%',
        width: '250px',
        padding: '40px',
        zIndex: 1,
        WebkitBoxShadow: '1px 5px 8px 0px rgba(35,86,210,0.05)',
        MozBoxShadow: '1px 5px 8px 0px rgba(35,86,210,0.05)',
        boxShadow: '1px 5px 8px 0px rgba(35,86,210,0.05)',
    },
    sideBarTitle: {
        fontSize: '20px',
        color: '#3D568F',
        fontWeight: 600,
    },
    navList: {
        marginTop: '40px',
    },
    navItem: {
        color: 'white',
        marginBottom: '20px',
    },
    settingsSectionWrapper: {
        background: '#ebecf0',
        height: '100%',
        overflow: 'auto',
        zIndex: 0,
    },
};

const commonStyles = {
    wrapper: {
        padding: '40px 40px 0 40px',
        overflow: 'auto',
        margin: '30px',
        background: '#FFFFFF',
        borderRadius: '20px',
        maxHeight: 'calc(100vh - 125px)'
    },
    title: {
        color: '#3D568F',
        fontSize: '22px',
        fontWeight: 600,
        marginBottom: '45px',
    },
    smallTitle: {
        fontSize: '16px',
        marginBottom: '10px',
        marginTop: '12px',
        fontWeight: 100,
        color: '#09183A',
    },
};

const Index = (props) => {
    const {
        match, user, company, addNotification,
    } = props;
    const defaultProps = {
        user,
        company,
        addNotification,
        commonStyles,
    };

    const role = getMemberRole(user).id;
    const {tariff} = company
    const {features} = company.tariff;

    return (
        <div className="full-height management un-selectable">
            <div className="settings-section-wrapper" style={styles.settingsSectionWrapper}>
                <Switch>
                    {(role === config.rolesMap.owner || role === config.rolesMap.admin)
                        && (tariff.status === config.tariffStatusMap.active
                            || tariff.status === config.tariffStatusMap.trial
                            || tariff.status === config.tariffStatusMap.paymentRequired) && (
                            <Route path={`${match.url}/company`}
                                   render={routeProps => <Company {...routeProps} {...defaultProps} />}/>
                        )}

                    {(role === config.rolesMap.owner || role === config.rolesMap.admin)
                       && (tariff.status === config.tariffStatusMap.active
                            || tariff.status === config.tariffStatusMap.trial) && (
                        <Route path={`${match.url}/clients`}
                               render={routeProps => <Clients {...routeProps} {...defaultProps} />}/>
                    )}

                    {(role === config.rolesMap.owner || role === config.rolesMap.admin)
                        && features.includes(config.features.USER_MANAGEMENT)
                        && (tariff.status === config.tariffStatusMap.active
                            || tariff.status === config.tariffStatusMap.trial)
                        && (
                            <Route path={`${match.url}/members`}
                                   render={routeProps => <Members {...routeProps} {...defaultProps} />}/>
                        )}

                    {(role === config.rolesMap.owner || role === config.rolesMap.admin)
                        && features.includes(config.features.STATISTICS)
                        && (tariff.status === config.tariffStatusMap.active
                            || tariff.status === config.tariffStatusMap.trial)
                        && (
                            <Route path={`${match.url}/statistics`} render={routeProps =>
                                <Statistics {...routeProps} {...defaultProps} />}/>)
                    }

                    {(role === config.rolesMap.owner || role === config.rolesMap.admin)
                        && features.includes(config.features.HISTORY)
                        && (tariff.status === config.tariffStatusMap.active
                            || tariff.status === config.tariffStatusMap.trial)
                        && (
                            <Route path={`${match.url}/history`}
                                   render={routeProps => <History {...routeProps} {...defaultProps} />}/>
                        )}

                    {(role === config.rolesMap.owner || role === config.rolesMap.admin) && (
                        <Route path={`${match.url}/`} render={() => (<Redirect to={`${match.url}/company`}/>)}/>
                    )}

                </Switch>
            </div>
        </div>
    );
};

Index.propTypes = {
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    addNotification: PropTypes.func.isRequired,
};


export default Radium(Index);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/index.jsx